module.exports = __webpack_public_path__ + "HP_Latex_1000-2000_2.jpg?6e12966633efba4c2f6bae63a1c1d714";